// Module
var code = "<div class=\"bg-gray-200 flex justify-center min-h-screen\"> <div class=\"w-full max-w-md mt-12\"> <div class=\"bg-white shadow-lg rounded p-8\"> <login-form @logged-in=\"loggedIn()\" @two-factor=\"showTwoFactor = true\" :open-forgot-password=\"openForgotPassword\"></login-form> </div> </div> </div> ";
// Exports
export default code;